import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
// eslint-disable-next-line import/named
import { Text, mergeStyleSets } from '@fluentui/react';
import { getPricingLocale } from '@shared/utils/pricing';
const classes = mergeStyleSets({
    customMeterRoot: {
        whiteSpace: 'break-spaces'
    },
    plusText: {
        marginTop: 10
    }
});
export const CustomMeterPricingMaxFractionDigits = 5;
const MetersInclude = ({ customMeter, variant }, context)=>{
    const includedMeters = customMeter.filter((cm)=>cm.includedQuantity !== '0');
    if (!includedMeters.length) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                variant: variant,
                block: true,
                children: context.loc('CustomMeter_Includes', 'Includes:')
            }),
            includedMeters.map((meter)=>/*#__PURE__*/ _jsx(Text, {
                    block: true,
                    variant: variant,
                    children: `${meter.title}: ${meter.includedQuantity}`
                }, meter.availabilityId))
        ]
    });
};
const MetersBreakdown = ({ sku, customMeter, billingCountry, variant, locale }, context)=>{
    const { countryCode } = billingCountry;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                block: true,
                className: classes.plusText,
                variant: variant,
                children: context.loc('CustomMeter_Plus', 'Plus:')
            }),
            customMeter.map((meter)=>{
                const localeString = getPricingLocale({
                    locale,
                    countryCode
                });
                const priceString = meter.rate.toLocaleString(localeString, {
                    style: 'currency',
                    currency: sku.currencyCode,
                    maximumFractionDigits: CustomMeterPricingMaxFractionDigits
                });
                return /*#__PURE__*/ _jsx(Text, {
                    block: true,
                    variant: variant,
                    children: `${meter.title}: ${priceString} ${meter.unit.toLowerCase()}`
                }, meter.availabilityId);
            })
        ]
    });
};
export const CustomMeterPricing = ({ price, billingCountry, sku, variant, locale })=>{
    const { customMeter } = price;
    if (!(customMeter === null || customMeter === void 0 ? void 0 : customMeter.length)) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: classes.customMeterRoot,
        children: [
            /*#__PURE__*/ _jsx(MetersInclude, {
                customMeter: customMeter,
                variant: variant
            }),
            /*#__PURE__*/ _jsx(MetersBreakdown, {
                sku: sku,
                billingCountry: billingCountry,
                customMeter: customMeter,
                variant: variant,
                locale: locale
            })
        ]
    });
};
MetersInclude.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
MetersBreakdown.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
